import ProcessTrueHazardEventModal from './process-true-hazard-event-modal.vue'
export default ProcessTrueHazardEventModal
